<template>
    <input
        :id="question.label"
        type="email"
        class="form_control"
        :placeholder="question.placeholder"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
